import { makeStyles } from 'tss-react/mui';
import { teceoGrayPrimary } from '../../../Theme';

export const getHeaderRowIconsStyles = (side: 'left' | 'right') => ({
  top: 24,
  [side]: 24,
  minHeight: 28,
  display: 'flex',
  position: 'absolute',
  alignItems: 'center',
  color: 'primary.contrastText',
  gap: side === 'left' ? 1 : 1.5,
});

export const getArrowButtonStyles = (side: 'left' | 'right') => ({
  [side]: 32,
  position: 'absolute',
  bottom: '50%',
  color: 'white',
  backgroundColor: `${teceoGrayPrimary}99`,
  '&:hover': {
    backgroundColor: `${teceoGrayPrimary}de`,
  },
});

export const useMediasPreviewStyles = makeStyles()({
  dialogPaperProps: {
    display: 'flex',
    overflow: 'hidden',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: 'transparent',
  },
  mediaContainer: {
    width: '70vw',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    boxSizing: 'border-box',
    filter: `
      drop-shadow(7px 0px 8px rgba(0,0,0,0.12))
      drop-shadow(0px -5px 8px rgba(0,0,0,0.14))
      drop-shadow(0px 12px 8px rgba(0,0,0,0.20))
      drop-shadow(-7px 0px 8px rgba(0,0,0,0.12))
    `,
  },
  textOverflow: {
    maxWidth: '50vw',
    overflow: 'hidden',
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
  },
});
